export default {
  'paymentHistory.time.last_three_months': 'ช่วง 3 เดือนที่ผ่านมา',
  'paymentHistory.time.last_six_months': 'ช่วง 6 เดือนที่ผ่านมา',
  'paymentHistory.time.last_one_year': 'ช่วง 1 ปีที่ผ่านมา',
  'paymentHistory.status.completed': 'ทำรายการเสร็จสิ้น',
  'paymentHistory.status.canceled': 'ยกเลิกรายการแล้ว',
  'paymentHistory.status.partial_canceled': 'ยกเลิกบางส่วน',
  'paymentHistory.title': 'ประวัติการทำรายการ',
  'paymentHistory.detail': 'รายละเอียดการทำรายการ',
  'paymentHistory.update_time': 'เวลา',
  'paymentHistory.total_amount': 'ยอดรวมทั้งหมด',
  'paymentHistory.store': 'ร้านค้า',
  'paymentHistory.status': 'สถานะ',
  'paymentHistory.level_progress_text.amounts':
    'ใช้จ่ายอีก <span style="font-weight: 600;color: #05B34D;">{amount}</span> บาท',
  'paymentHistory.level_progress_text.counts':
    'ใช้จ่ายอีก <span style="font-weight: 600;color: #05B34D;">{count}</span> ครั้ง ครั้งละอย่างน้อย <span style="font-weight: 600;color: #05B34D;">{amount}</span> บาทเพื่ออัปเกรดระดับ',
  'paymentHistory.level_progress_text.or': 'หรือ',
  'paymentHistory.period_amount': 'ยอดใช้จ่ายสะสมในช่วงระยะเวลา',
  'paymentHistory.member_total_amount': 'ยอดการใช้จ่ายสะสมทั้งหมดของสมาชิก',
  'paymentHistory.dollar': 'บาท',
  'paymentHistory.zero_dollar': '0 บาท',
  'paymentHistory.trade_time': 'เวลาทำรายการ',
  'paymentHistory.empty': 'ไม่มีข้อมูลรายการ',
  'paymentHistory.name': 'ชื่อรายการ',
  'paymentHistory.quantity': 'จำนวน',
  'paymentHistory.price': 'ราคาต่อหน่วย',
  'paymentHistory.amount': 'จำนวนเงินที่ใช้จ่าย',
  'paymentHistory.cancel_date': 'วันที่ยกเลิก',
} as Record<string, string>;
